import './project-section.scss';

export default () => {
	if ( $( '.project-section' ).length ) {
		$( '.heading' ).addClass( 'heading--small' );
	}


	let btn = $( '#load-more' );
	let blog = '.project-section__item';

	function recall ( btn, blog ) {
		btn.on( 'click', function ( e ) {
			e.preventDefault();
			let nextBtn = $( this );
			let next_page = nextBtn.attr( 'href' );

			$( '<div id="articles2" style="display: none">' ).load( `${next_page} ${blog}`, function () {
				$( '#articles' ).append( this );
				const articleNew = document.getElementById( 'articles2' );

				articleNew.replaceWith( ...articleNew.childNodes );

				nextBtn.parent().load( `${next_page} #load-more`, function () {
					recall( $( '#load-more' ), blog );
				} );
			} );
		} );
	}
	recall( btn, blog );
};
